import { collectionRef } from "./firebase";
import {CONFIG_COLLECTION, CONFIG_IM_TIME, CONFIG_WORKDAY} from '../config/CONSTANTS'

export const onUpdateRemoteConfig = (callback) => {
  return collectionRef(CONFIG_COLLECTION)
    .doc(CONFIG_IM_TIME)
    .onSnapshot(async (snapshot) => {
      console.log("Remote Config", snapshot.data())
      if (snapshot.exists) {
        await callback(snapshot.data());
      }
    });
};

export const getWorkdayConfigDetails = async () => {
  console.log("services > rcConfig > getWorkdayConfigDetails called...");
  return new Promise(async (res, rej) => {
    try {
      const snapshot = await collectionRef(CONFIG_COLLECTION)
        .doc(CONFIG_WORKDAY)
        .get();
      console.log(
        "in services > rcConfig > getWorkdayConfigDetails [SUCCESS]"
      );
      res(snapshot.data() || {});
    } catch (error) {
      console.error(
        "in services > rcConfig > getWorkdayConfigDetails, err===" + error
      );
      rej(error);
    }
  });
};
